import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { CAMERA_SVG, MOBILE_SVG } from "../../../utils/svgs";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppBoxActionCard } from "../../Generic/AppBoxActionCard";
import { AppBoxActionCards } from "../../Generic/AppBoxActionCards";

interface Props {
  isOpen: boolean;
  onClickOpenCamera: () => void;
  onClickOpenGallery: () => void;
  onRequestClose: () => void;
}

function ComplianceUploadDocumentModal(props: Props) {
  return (
    <AppBottomSheet
      isOpen={props.isOpen}
      rounded={true}
      title={translate(STRINGS.HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE)}
      onRequestClose={props.onRequestClose}
    >
      <AppBoxActionCards>
        <AppBoxActionCard
          icon={CAMERA_SVG}
          label={translate(STRINGS.SCAN_A_PHOTO)}
          onClick={props.onClickOpenCamera}
        />
        <AppBoxActionCard
          icon={MOBILE_SVG}
          label={translate(STRINGS.UPLOAD_FROM_GALLERY)}
          onClick={props.onClickOpenGallery}
        />
      </AppBoxActionCards>
    </AppBottomSheet>
  );
}

export default ComplianceUploadDocumentModal;
